<template>
  <div class="box-upload-container" v-if="isShowDialog">
    <div class="d-flex align-center justify-space-between" style="height: 50px">
      <div
        style="font-size: 18px; font-weight: bold; color: #1F1F1F; padding-left: 15px;"
      >
        Dữ liệu tải lên {{ countSuccess }} / {{ progressFiles.length }} mục
      </div>
      <v-btn icon @click="handleCancelAll">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-divider></v-divider>
    <div>
      <div
        v-for="file in progressFiles"
        :key="file.id"
        class="queue-item"
        :class="{ 'queue-item--error': isItemError(file) }"
        style="padding-right: 15px; padding-left: 15px; margin-top: 15px;"
      >
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex align-center overflow-hidden">
            <div class="type-data" :class="{ 'type-data--error': isItemError(file) }">
              {{ file.type }}
            </div>
            <div class="overflow-hidden">
              <div
                style="font-size: 18px;"
                class="text-truncate"
                :class="{ 'error--text': isItemError(file) }"
              >
                {{ file.name }}
              </div>
              <div
                v-if="file.error_message"
                class="error--text"
                style="font-size: 14px;"
              >
                {{ file.error_message }}
              </div>
              <div
                v-else-if="file.statusMessage && !file.isDone"
                style="color: #898989; font-size: 14px;"
              >
                {{ file.statusMessage }}
              </div>
              <div
                v-if="hasChildren(file)"
                style="font-size: 12px;"
                :class="childErrorCount(file) ? 'error--text' : 'grey--text'"
              >
                Thành công {{ childSuccessCount(file) }}/{{
                  childTotal(file)
                }}
                <span v-if="childErrorCount(file)">
                  · Thất bại {{ childErrorCount(file) }}
                </span>
              </div>
            </div>
          </div>
          <div class="d-flex align-center flex-shrink-0">
            <v-btn
              v-if="hasChildren(file)"
              icon
              x-small
              class="mr-1"
              @click="toggleExpand(file.id)"
            >
              <v-icon small>
                {{
                  isExpanded(file.id) ? 'mdi-chevron-up' : 'mdi-chevron-down'
                }}
              </v-icon>
            </v-btn>
            <v-progress-circular
              v-if="!file.isDone"
              :size="25"
              :width="3"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <div v-else>
              <v-icon v-if="file.isError" color="error">
                mdi-alert-circle
              </v-icon>
              <v-icon v-else style="color: green">
                mdi-checkbox-marked-circle
              </v-icon>
            </div>
          </div>
        </div>
        <div
          v-if="hasChildren(file) && isExpanded(file.id)"
          class="mt-2"
          style="padding-left: 85px;"
        >
          <div
            v-for="child in file.children"
            :key="child.id"
            class="d-flex align-center justify-space-between mb-1 child-row"
            :class="{ 'child-row--error': child.isError }"
          >
            <div class="overflow-hidden pr-2">
              <div
                class="text-truncate"
                style="font-size: 13px;"
                :class="{ 'error--text font-weight-medium': child.isError }"
              >
                {{ child.name }}
              </div>
              <div
                v-if="child.error_message"
                class="error--text"
                style="font-size: 12px;"
              >
                {{ child.error_message }}
              </div>
              <div
                v-else-if="child.statusMessage && !child.isDone"
                style="color: #898989; font-size: 12px;"
              >
                {{ child.statusMessage }}
              </div>
            </div>
            <div>
              <v-progress-circular
                v-if="!child.isDone"
                :size="16"
                :width="2"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <v-icon
                v-else-if="child.isError"
                small
                color="error"
              >
                mdi-alert-circle
              </v-icon>
              <v-icon v-else small style="color: green">
                mdi-checkbox-marked-circle
              </v-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { ConfirmBuilder } from '@utils'

export default {
  name: 'box-upload',
  data: () => ({
    expandedIds: {},
  }),
  computed: {
    ...mapGetters({
      isShowDialog: 'datastore/isShowDialog',
      progressFiles: 'datastore/progressFiles',
    }),
    countDone() {
      return this.progressFiles.filter((x) => x.isDone).length
    },
    countSuccess() {
      return this.progressFiles.filter((x) => !x.isError && x.isDone).length
    },
  },
  watch: {
    isShowDialog(value) {
      if (!value) this.expandedIds = {}
    },
    progressFiles: {
      deep: true,
      handler(files) {
        (files || []).forEach((file) => {
          if (this.childErrorCount(file)) {
            this.$set(this.expandedIds, file.id, true)
          }
        })
      },
    },
  },
  methods: {
    isItemError(file) {
      return !!(file && (file.isError || this.childErrorCount(file)))
    },
    hasChildren(file) {
      return !!(file && file.children && file.children.length)
    },
    childTotal(file) {
      return this.hasChildren(file) ? file.children.length : 0
    },
    childSuccessCount(file) {
      if (!this.hasChildren(file)) return 0
      return file.children.filter((child) => child.isDone && !child.isError)
        .length
    },
    childErrorCount(file) {
      if (!this.hasChildren(file)) return 0
      return file.children.filter((child) => child.isError).length
    },
    isExpanded(id) {
      return !!this.expandedIds[id]
    },
    toggleExpand(id) {
      this.$set(this.expandedIds, id, !this.expandedIds[id])
    },
    async handleCancelAll() {
      if (this.countDone < this.progressFiles.length) {
        const confirm = new ConfirmBuilder()
        confirm
          .addMessage('Bạn có chắc chắn muốn hủy toàn bộ quá trình tải dữ liệu')
          .setTitle('Hủy tải dữ liệu')
          .setType('delete')
        if (await confirm.confirm()) {
          this.$store.dispatch('datastore/cancelAll')
        }
      } else this.$store.dispatch('datastore/cancelAll')
    },
  },
}
</script>
<style scoped>
.d-flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.justify-space-between {
  justify-content: space-between;
}

.box-upload-container {
  width: 350px;
  position: fixed;
  background: white;
  bottom: 40px;
  right: 10px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em,
    rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em,
    rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  padding-bottom: 20px;
}

.type-data {
  padding: 3px;
  padding-left: 6px;
  padding-right: 6px;
  width: 65px;
  border: 1px solid #0e6655;
  border-radius: 16px;
  margin-right: 20px;
  font-size: 13px;
  color: #935116;
  text-align: center;
  flex-shrink: 0;
}
.type-data--error {
  border-color: #e53935;
  color: #c62828;
  background: #ffebee;
}
.queue-item--error {
  background: #ffebee;
  border-radius: 8px;
  margin-left: 8px;
  margin-right: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.child-row--error {
  background: #ffcdd2;
  border-radius: 4px;
  padding: 4px 6px;
}
</style>
